import React, { useEffect, useRef } from 'react';
import renderHTML from 'react-render-html';
import './TextItem.sass';
const TextItem = ({ data }) => {
    let text_item = useRef();

    return (
        <div
            ref={(el) => (text_item = el)}
            id={data.id}
            style={data.style || {}}
            className={"text-item "+(data.classNames || '')}
        >
            {renderHTML(data.content)}
        </div>
    );
};

export default TextItem;